<template>
	<div>
		<v-card class="ma-4">
			<v-card-title class="mb-3">
				<h2>{{item.name}} ({{item.shortName}})</h2>
			</v-card-title>
		</v-card>
		<router-view></router-view>
	</div>
</template>

<script>
import {AgencyContest} from "@/api/generated/AgencyContest";

export default {
  name: "AgencyContestNameView",

  methods: {
    updateNames (name, shortName) {
      this.item.name = name;
      this.item.shortName = shortName;
    }
  },

  created() {
    AgencyContest.getPanelInfo(this, this.$route.params.id, response => {
      this.item.name = response.name;
      this.item.shortName = response.shortName;
    });
  },

  data() {
    return {
      item: {
        name: "",
        shortName: ""
      }
    };
  },
};
</script>

<style scoped>

</style>